/**
 * Fonctionnalité activée par le rôle Keycloak, utilisateur par utilisateur.
 *
 * Isolé de `SendNotificationView` parce que le menu en a besoin : importé depuis la page, il
 * ramenait dans le bundle d'entrée tout l'écran d'envoi et son éditeur MDX (APP-4833).
 */
export const NOTIFICATION_ROLE = "api-notification";
